export default function Ecosystem() {
  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Left Column - Text Only */}
        <div className="max-w-5xl">
          {/* Heading */}
          <div className="mb-10">
            <div className="flex items-start gap-4">
              <div className="w-1.5 h-40 bg-[#D4AF37] flex-shrink-0"></div>
              <h2 className="text-4xl md:text-5xl font-black text-[#1A2B4A] leading-tight font-serif">
                ディーラー側にも大きなメリットがある<br />
                <span className="text-[#D4AF37]">Win-Win</span> の構造。<br />
                <span className="text-3xl">全国のディーラーがこぞって「顧客」を運んでくる驚異のエコシステム</span>
              </h2>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed font-serif">
            <p className="text-xl font-bold text-[#1A2B4A]">
              私たちが広告費をかけて集客することはありません。
            </p>
            <p>
              全国の自動車ディーラーには、毎日「ローンが通らず、車を売ることができなかった顧客」が訪れます。彼らにとって、私たちの仕組みは<span className="text-[#D4AF37] font-bold text-xl">「売れないはずだった車を売るための、唯一の解決策」</span>なのです。
            </p>

            {/* Benefits List */}
            <div className="bg-[#F8F9FA] p-8 rounded-2xl mt-8">
              <h3 className="text-xl font-bold text-[#1A2B4A] mb-6 font-serif">ディーラーのメリット</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#D4AF37] text-2xl flex-shrink-0"></i>
                  <span className="text-gray-700 font-serif">断られた顧客にも車を販売できる</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#D4AF37] text-2xl flex-shrink-0"></i>
                  <span className="text-gray-700 font-serif">在庫回転率の向上</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#D4AF37] text-2xl flex-shrink-0"></i>
                  <span className="text-gray-700 font-serif">新たな収益源の確保</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
